// 더미 데이터: 영차매니저 목록
export const managers = [
  {
    id: 1,
    name: '김철수',
    emoji: '🧑',
    rating: 4.9,
    reviews: 312,
    distance: 0.3,
    status: 'online',
    statusLabel: '지금 가능',
    vehicle: '1톤 트럭',
    area: '마포구',
    tags: ['대형가구', '포장이사', '신속'],
    lng: 126.923,
    lat: 37.556,
    price: 15000,
    completedJobs: 312,
    joinDate: '2024.03',
    verificationBadge: true,
  },
  {
    id: 2,
    name: '이영희',
    emoji: '👩',
    rating: 4.8,
    reviews: 205,
    distance: 0.7,
    status: 'online',
    statusLabel: '지금 가능',
    vehicle: '다마스',
    area: '서대문구',
    tags: ['소형가구', '정밀포장'],
    lng: 126.931,
    lat: 37.562,
    price: 12000,
    completedJobs: 205,
    joinDate: '2024.06',
    verificationBadge: true,
  },
  {
    id: 3,
    name: '박민준',
    emoji: '🧔',
    rating: 4.7,
    reviews: 178,
    distance: 1.2,
    status: 'busy',
    statusLabel: '30분 후 가능',
    vehicle: '2.5톤 트럭',
    area: '은평구',
    tags: ['장거리', '공차매칭', '친절'],
    lng: 126.917,
    lat: 37.549,
    price: 18000,
    completedJobs: 178,
    joinDate: '2023.11',
    verificationBadge: true,
  },
  {
    id: 4,
    name: '정수아',
    emoji: '👩‍🦱',
    rating: 5.0,
    reviews: 89,
    distance: 1.5,
    status: 'online',
    statusLabel: '지금 가능',
    vehicle: '1톤 트럭',
    area: '용산구',
    tags: ['여성친화', '검증전문'],
    lng: 126.944,
    lat: 37.540,
    price: 14000,
    completedJobs: 89,
    joinDate: '2025.01',
    verificationBadge: false,
  },
  {
    id: 5,
    name: '최동현',
    emoji: '👨‍🦲',
    rating: 4.6,
    reviews: 427,
    distance: 2.1,
    status: 'online',
    statusLabel: '지금 가능',
    vehicle: '5톤 트럭',
    area: '강서구',
    tags: ['대형물품', '장거리', '가성비'],
    lng: 126.899,
    lat: 37.558,
    price: 22000,
    completedJobs: 427,
    joinDate: '2023.05',
    verificationBadge: true,
  },
];

// 더미 데이터: 용달차(공차) 목록
export const trucks = [
  {
    id: 1,
    driver: '홍길동',
    emoji: '🚚',
    vehicle: '2.5톤 탑차',
    plateNo: '서울 12가 3456',
    from: '부산 → 서울',
    route: '부산광역시 → 서울특별시 마포구',
    eta: '오늘 오후 4시',
    remainKm: 320,
    loadCapacity: '70%',
    loadText: '적재 여유 있음',
    lat: 36.2,
    lng: 127.5,
    rating: 4.8,
    phone: '010-XXXX-XXXX',
    discountRate: 40,
    type: 'longDistance',
    typeLabel: '장거리 공차',
  },
  {
    id: 2,
    driver: '이상민',
    emoji: '🚐',
    vehicle: '1톤 트럭',
    plateNo: '경기 34나 5678',
    from: '인천 → 서울',
    route: '인천광역시 → 서울특별시 서대문구',
    eta: '오늘 오후 2시',
    remainKm: 40,
    loadCapacity: '30%',
    loadText: '적재 여유 충분',
    lat: 37.46,
    lng: 126.72,
    rating: 4.9,
    phone: '010-XXXX-XXXX',
    discountRate: 50,
    type: 'returning',
    typeLabel: '귀환 공차',
  },
  {
    id: 3,
    driver: '강지원',
    emoji: '🚛',
    vehicle: '5톤 트럭',
    plateNo: '서울 56다 7890',
    from: '대전 → 서울',
    route: '대전광역시 → 서울특별시 강남구',
    eta: '오늘 저녁 7시',
    remainKm: 140,
    loadCapacity: '50%',
    loadText: '적재 가능',
    lat: 36.35,
    lng: 127.38,
    rating: 4.7,
    phone: '010-XXXX-XXXX',
    discountRate: 35,
    type: 'longDistance',
    typeLabel: '장거리 공차',
  },
  {
    id: 4,
    driver: '윤미래',
    emoji: '🚌',
    vehicle: '다마스',
    plateNo: '서울 78라 0123',
    from: '강남구 → 마포구',
    route: '서울 강남구 → 서울 마포구',
    eta: '오늘 오전 11시',
    remainKm: 12,
    loadCapacity: '10%',
    loadText: '소형 물건 가능',
    lat: 37.497,
    lng: 127.027,
    rating: 4.6,
    phone: '010-XXXX-XXXX',
    discountRate: 30,
    type: 'idle',
    typeLabel: '대기 중',
  },
];

// 가구 카테고리별 AI 분석 데이터
export const furnitureData = {
  sofa: {
    name: '소파 (3인용)',
    weight: '35~55kg',
    size: '210×85×90cm',
    difficulty: '중',
    elevatorNeeded: true,
    twoPersonRequired: true,
    estimatedTime: 30,
    recommendedVehicle: '1톤 트럭 이상',
  },
  wardrobe: {
    name: '옷장 (대형)',
    weight: '80~120kg',
    size: '180×60×200cm',
    difficulty: '상',
    elevatorNeeded: true,
    twoPersonRequired: true,
    estimatedTime: 60,
    recommendedVehicle: '2.5톤 트럭',
  },
  bed: {
    name: '침대 (퀸)',
    weight: '50~80kg',
    size: '160×200×35cm',
    difficulty: '중',
    elevatorNeeded: true,
    twoPersonRequired: true,
    estimatedTime: 45,
    recommendedVehicle: '1톤 트럭 이상',
  },
  desk: {
    name: '책상',
    weight: '20~40kg',
    size: '120×60×75cm',
    difficulty: '하',
    elevatorNeeded: false,
    twoPersonRequired: false,
    estimatedTime: 20,
    recommendedVehicle: '다마스',
  },
  refrigerator: {
    name: '냉장고',
    weight: '60~100kg',
    size: '70×75×170cm',
    difficulty: '상',
    elevatorNeeded: true,
    twoPersonRequired: true,
    estimatedTime: 45,
    recommendedVehicle: '1톤 트럭 이상',
  },
  dining: {
    name: '식탁세트',
    weight: '40~70kg',
    size: '140×80×75cm',
    difficulty: '중',
    elevatorNeeded: true,
    twoPersonRequired: true,
    estimatedTime: 40,
    recommendedVehicle: '1톤 트럭',
  },
  bookshelf: {
    name: '책장',
    weight: '30~60kg',
    size: '80×30×180cm',
    difficulty: '하',
    elevatorNeeded: false,
    twoPersonRequired: true,
    estimatedTime: 25,
    recommendedVehicle: '다마스',
  },
};

// 요금 계산 기준
export const pricingRules = {
  base: 10000,
  perKm: 2000,
  elevatorFee: 5000,
  stairFee: { perFloor: 3000 },
  heavyItemFee: 5000, // 50kg 이상
  verificationFee: 15000, // 현장 검증비
  washingFee: 10000, // 세척 서비스
  assemblyFee: 20000, // 조립 서비스
};

// 리뷰 더미 데이터
export const reviews = [
  { id: 1, user: '당근마켓 구매자', rating: 5, comment: '소파 운반 정말 꼼꼼하게 해주셨어요. 사진도 찍어서 보내주시고 완전 만족!', date: '2026.02.28' },
  { id: 2, user: '중고나라 이용자', rating: 5, comment: '냉장고 검증 서비스 최고! 혹시 모를 하자도 미리 확인해서 안심하고 구매했어요.', date: '2026.02.25' },
  { id: 3, user: '번개장터 구매자', rating: 4, comment: '이사 후 귀환 공차 서비스로 50% 절약했습니다. 강추!', date: '2026.02.20' },
];

// 진행 중인 배송 더미
export const activeDelivery = {
  id: 'ORD-20260303-0042',
  status: 3,
  statusSteps: [
    { label: '요청 완료', time: '09:30', done: true },
    { label: '매니저 배정', time: '09:35', done: true },
    { label: '현장 출발', time: '10:05', done: true },
    { label: '물품 검증 중', time: '10:30', done: false },
    { label: '세척 완료', time: '-', done: false },
    { label: '배송 출발', time: '-', done: false },
    { label: '배송 완료', time: '-', done: false },
  ],
  manager: { name: '김철수', phone: '010-XXXX-XXXX', vehicle: '1톤 트럭', plate: '서울 12가 3456' },
  item: '3인용 소파',
  from: '서울 마포구 합정동',
  to: '서울 은평구 응암동',
  price: 35000,
  eta: '오후 1시 30분',
};
